import type { OptJobType } from 'api/optJobs/optJobs.api'
import type { OptimizationSubtypeOption } from 'views/DigitalTwinCollectedSettingsView/DigitalTwinCollectedSettingsView.helper'

/** Outcome is always the measured values, whichever Optimization type option is selected. */
export const OUTCOME_OPTJOB_TYPE: OptJobType = 'measvalues_calculations'

type OptJobTypeIds = { optimal: number; outcome: number }

/**
 * The aliases the selected Optimization type option resolves the table with: optimal on the option's job
 * type, outcome on `OUTCOME_OPTJOB_TYPE`, and the option's priority levels.
 */
export function toOptimizationTypeAliases(
  option: OptimizationSubtypeOption,
  priorityLevelsHighestFirst: number[],
  optJobTypeIds: OptJobTypeIds
): UiConfigAliases {
  return {
    priority_levels: priorityLevelsHighestFirst,
    optjob_type: option.optJobType,
    optimal_optjob_type: option.optJobType,
    optimal_opt_job_type_id: optJobTypeIds.optimal,
    outcome_optjob_type: OUTCOME_OPTJOB_TYPE,
    outcome_opt_job_type_id: optJobTypeIds.outcome,
  }
}
